<template>
  <div>
    <ServiceProviderList />
    <ServiceProviderCreateUpdate ref="createUpdate" />
    <ServiceProviderDeleteModal />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import ServiceProviderList from './serviceProvider/components/ServiceProviderList'
import ServiceProviderCreateUpdate from './serviceProvider/components/ServiceProviderCreateUpdate'
import ServiceProviderDeleteModal from './serviceProvider/components/ServiceProviderDeleteModal'

export default {
  name: 'ServiceProviders',

  components: {
    ServiceProviderList,
    ServiceProviderCreateUpdate,
    ServiceProviderDeleteModal,
  },

  methods: {
    ...mapActions(['handleOpenCreateUpdateServiceProviderModal']),
  },
}
</script>
